module.exports = __webpack_public_path__ + "./Nine_color_d2a7430f2582fe1db8fdb2d99c27b543.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/sectionTalking/2023/Nine_color.jpg
// module id = 602
// module chunks = 0